import {
  DTableProps,
  CombinedText,
  StatusChip,
  StatusChipColors,
  DarwinSelect,
  ACTIONS_COL_WIDTH,
  ActionsDropdown,
  STATUS_COL_WIDTH,
  DMenuProps,
} from '@darwin-ui';
import { TFunction } from 'i18next';
import {
  ControlDocument,
  EditedControlDocumentItem,
} from 'types/controlDocumentsTypes';
import styles from './index.module.css';

export const getControlDocumentsColumns = (
  t: TFunction,
  actionItems: (item: ControlDocument) => DMenuProps['items'],
  searchQuery: string,
  editedItems: Record<string, EditedControlDocumentItem>,
  onAliasesChange: (id: string, newAliases: string[]) => void
): DTableProps<ControlDocument>['columns'] => [
  {
    title: t('control-documents.columns.name'),
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    render: (_: unknown, record: ControlDocument) => (
      <CombinedText
        lines={1}
        text={t(record.translationKey)}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('control-documents.columns.description'),
    dataIndex: 'description',
    key: 'description',
    sorter: true,
    render: (_: unknown, record: ControlDocument) => (
      <CombinedText
        lines={1}
        text={t(`${record.translationKey}_DESCRIPTION`)}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('control-documents.columns.aliases'),
    dataIndex: 'aliases',
    key: 'aliases',
    render: (_: any, record: ControlDocument) => {
      const key = String(record.id);
      const currentAliases = editedItems[key]?.aliases ?? record.aliases ?? [];

      return (
        <DarwinSelect
          mode="tags"
          open={false}
          suffixIcon={null}
          value={currentAliases}
          onChange={(values: string[]) => onAliasesChange(key, values)}
          className={styles['control-documents-aliases-select']}
        />
      );
    },
    width: 400,
  },
  {
    title: t('control-documents.columns.status'),
    dataIndex: 'isActive',
    key: 'isActive',
    sorter: true,
    render: (_: any, record: ControlDocument) => {
      const key = String(record.id);
      const isActive = editedItems[key]?.active ?? record.isActive;

      return (
        <div className={styles['control-documents-actions']}>
          <StatusChip
            label={
              isActive
                ? t('control-documents.columns.active')
                : t('control-documents.columns.inactive')
            }
            color={isActive ? StatusChipColors.green : StatusChipColors.red}
          />
        </div>
      );
    },
    width: STATUS_COL_WIDTH,
  },
  {
    dataIndex: 'actions',
    key: 'actions',
    fixed: 'right',
    align: 'center',
    render: (_: any, record: ControlDocument) => (
      <ActionsDropdown item={record} getMenuItems={actionItems} />
    ),
    width: ACTIONS_COL_WIDTH,
  },
];
